import { DealRequestAllocation } from '../../shared/models';
import { ReactComponent as WorkingCapital } from '../../shared/icons/WorkingCapital.svg';
import { DebtCapitalHeading } from './DebtCapitalHeading';
import {
	CerebroComplexListItem,
	CerebroHeading,
	CerebroLabel,
	CerebroStyledBox,
	CerebroText,
} from '../../shared/components';
import { Grid } from '@mui/material';
import { BooleanUtils } from '../../shared/utils';

interface DebtGrowthCapitalProps {
	allocation: DealRequestAllocation;
}

export const DebtGrowthCapital: React.FC<DebtGrowthCapitalProps> = ({ allocation }) => {
	const isEmpty = isGrowthCapitalEmpty(allocation);
	const amountRequested =
		(allocation.totalGrowthCapitalHardCostAmount ?? 0) + (allocation.totalGrowthCapitalSoftCostAmount ?? 0);

	return (
		<>
			<DebtCapitalHeading icon={WorkingCapital} amountRequested={amountRequested}>
				Working Capital
			</DebtCapitalHeading>

			{isEmpty ? (
				<CerebroStyledBox sx={{ marginBottom: 8 }}>
					<CerebroHeading size="h2" component="h2">
						No details have been added yet.
					</CerebroHeading>
					<br />
				</CerebroStyledBox>
			) : (
				<CerebroComplexListItem sx={{ marginTop: 2, marginBottom: 8 }}>
					<Grid container>
						<Grid item xs={6}>
							<CerebroLabel sx={{ marginTop: 1.5, marginBottom: 1.5 }}>
								Do you need to finance your accounts receivable?
							</CerebroLabel>
							<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
								{BooleanUtils.YesNo(allocation.workingCapitalImproveLiquidity)}
							</CerebroText>
						</Grid>
						<Grid item xs={6}>
							<CerebroLabel sx={{ marginTop: 1.5, marginBottom: 1.5 }}>
								Do you need to finance inventory?
							</CerebroLabel>
							<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
								{BooleanUtils.YesNo(allocation.workingCapitalPurchaseInventory)}
							</CerebroText>
						</Grid>
						<Grid item xs={6}>
							<CerebroLabel sx={{ marginTop: 1.5, marginBottom: 1.5 }}>
								Do you need capital for operating expenses (SG&amp;A)?
							</CerebroLabel>
							<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
								{BooleanUtils.YesNo(allocation.workingCapitalOperatingExpenses)}
							</CerebroText>
						</Grid>
					</Grid>
				</CerebroComplexListItem>
			)}
		</>
	);
};

export function isGrowthCapitalEmpty(allocation: DealRequestAllocation): boolean {
	return !allocation.totalGrowthCapitalHardCostAmount && !allocation.totalGrowthCapitalSoftCostAmount;
}
